export const navLinksdata = [
    {
      _id: 1001,
      label: "Home",
      key: "/",
    },
    {
      _id: 1002,
      label: 'About Us',
      key: '/about-us',
    },
    {
      _id: 1003,
     label: 'Services',
        key: '/services',
    },
    {
      _id: 1005,
      label: 'Products',
      key: '/products',
    },
    {
      _id: 1006,
      label: 'Solutions',
      key: '/solutions',
    },
    
  ];
  